import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "./CheckoutForm";

import instance from "../../../services/api";
import { config } from "../../common/Constants";

const stripePromise = loadStripe(config.stripePublishableKey);

const CheckoutScreen = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [clientSecret, setClientSecret] = useState("");
    const moduleId = location.state.module._id;

    useEffect(() => {
        window.scrollTo(0, 0);

        async function fetchData() {
            // Create PaymentIntent as soon as the page loads
            await instance.post("/payment/create-payment-intent", {
                moduleId: moduleId,
            }).then((response) => setClientSecret(response.data.clientSecret));
        }

        fetchData();
    }, [moduleId]);
    
    const appearance = {
        theme: 'stripe',
    };
    const options = {
        clientSecret,
        appearance,
    };

    return (
        <Container className="page-shell">
            {clientSecret && (
                <div className="page-section">
                    <section className="page-header">
                        <h3 className="page-title">Checkout</h3>
                        <p className="page-subtitle">Confirm module details and complete payment securely.</p>
                        <Button
                            variant="outline-secondary"
                            className="mt-2"
                            onClick={() => navigate("/my-modules")}
                        >
                            Back to My Modules
                        </Button>
                    </section>
                    <Row>
                        <Col xs={12} md={6}>
                            <Card className="h-100">
                                <Card.Body>
                                    <h4>Module</h4>
                                    <p className="fw-bold mb-1">{location.state.module.name}</p>
                                    <p className="text-muted mb-0">
                                        Year Levels: {location.state.module.yearLevelMin}-{location.state.module.yearLevelMax}
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col xs={12} md={6}>
                            <Card className="h-100">
                                <Card.Body>
                                    <h4>Price</h4>
                                    <p className="fw-bold mb-0">$495.00 AUD</p>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    <p className="mt-4 mb-3">Please enter your payment method and click Pay to complete your purchase.</p>
                    <Elements options={options} stripe={stripePromise}>
                        <CheckoutForm/>
                    </Elements>
                </div>
            )}
        </Container>
    );
}

export default CheckoutScreen;